import { Routes } from "@angular/router";
import { MainLayoutComponent } from "./shared/layouts/main-layout/main-layout.component";
import { tokenHandlerGuard } from "./modules/claims/_guards/token-handler.guard";

export const routes: Routes = [
    {
        path: "",
        canActivate: [tokenHandlerGuard],
        children: [],
    },
    {
        path: "claims",
        component: MainLayoutComponent,
        loadChildren: () => import("./modules/claims/claims.routes").then((m) => m.routes),
    },
    {
        path: "chubb",
        component: MainLayoutComponent,
        loadChildren: () => import("./modules/chubb-claims/chubb-claims.routes").then((m) => m.CHUBB_CLAIMS_ROUTES),
    },
    {
        path: "service",
        component: MainLayoutComponent,
        loadChildren: () => import("./modules/value-added-service/value-added-service.routes").then((m) => m.routes),
    },
    {
        path: "fresh",
        component: MainLayoutComponent,
        loadChildren: () => import("./modules/fresh-guarantee-claims/fresh-guarantee-claims.routes").then((m) => m.FRESH_GUARANTEE_CLAIMS_ROUTES),
    },
    {
        path: "allergy-claims",
        component: MainLayoutComponent,
        loadChildren: () => import("./modules/allergy-claims/allergy-claims.routes").then((m) => m.ALLERGY_CLAIMS_ROUTES),
    },
];
